import NetworkLogic from "../Shared/NetworkLogic";
import { Global } from "../Shared/Global";
import HallUI from "./HallUI";
import AudioManager from "../Shared/AudioManager";
import Player from "../Models/Player";
import SDKManager from "../Shared/SDKManager";
import UIManager from "../Shared/UIManager";
const i18n = require('LanguageData');

const { ccclass, property } = cc._decorator;

@ccclass
export default class LoginCompleteInformation extends cc.Component {
    @property(cc.Label)
    userId: cc.Label = null;
    @property(cc.EditBox)
    phone: cc.EditBox = null;
    @property(cc.EditBox)
    qq: cc.EditBox = null;
    @property(cc.EditBox)
    email: cc.EditBox = null;

    start() {
        //let userId = cc.sys.localStorage.getItem(Global.localStorageId.QuickLoginUserId)
        this.userId.string = Player.getPy("userID");
    }


    onBtnOk() {
        AudioManager.playSound("button");
        if (!this.phone.string || !this.qq.string || !this.email.string) {
            UIManager.showToastUI(i18n.t('register_text.inp_data'), Global.ToastType.Warnning)
            return
        }
        let data = {
            "userId": this.userId.string,
            "phone": this.phone.string,
            "qq": this.qq.string,
            "email": this.email.string
        };
        NetworkLogic.loginVisitorEditData(data, function (rec) {
            cc.log("===完善资料成功");
            UIManager.showToastUI(i18n.t('register_text.perfect_suc'), Global.ToastType.OK)
            Player.setPy("userType", 0)
            this.node.destroy()
        }.bind(this), function () {
            cc.log("===完善资料失败");
            UIManager.showToastUI(i18n.t('register_text.perfect_err'), Global.ToastType.Error)

        })
    }

    onBtnGoLogin() {
        AudioManager.playSound("button");
        let hallUI: HallUI = cc.find("Canvas/gameNode").getComponent("HallUI");
        hallUI.openChildUI(hallUI.pfbLoginUI);
        this.node.destroy()
    }

    onBtnClose() {
        AudioManager.playSound("close");
        this.node.destroy()
    }
}
